import {createEntityService} from 'utils/createEntityService';
import {Training} from 'types/training';

export const TrainingService = createEntityService<Training>({
  baseUrl: 'api/v1/trainings',
  entityName: 'training',
});
